import axios from 'axios'

export default class TipoAtuacao {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoEndereco`
    this.tokenBearer = tokenBearer
  }

  getEnderecos () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
